<div
  class="tw-w-full tw-p-4 {{ props }} tw-items-center tw-gap-2 {{
    visible ? 'tw-inline-flex' : 'tw-hidden'
  }} tw-justify-between tw-flex-1 tw-font-bold"
>
  <div class="tw-flex tw-items-center tw-space-x-10 tw-w-full tw-flex-1">
    <div>
      @switch (color) {
        @case ('success') {
          <span class="material-icons tw-mr-1">check_circle_outline</span>
        }
        @case ('primary') {
          <span class="material-icons tw-mr-1">info</span>
        }
        @case ('warning') {
          <span class="material-icons tw-mr-1">warning</span>
        }
        @case ('error') {
          <span class="material-icons tw-mr-1">error_outline</span>
        }
        @default {
          <span class="material-icons tw-mr-1">info</span>
        }
      }
    </div>
    <div class="-tw-mt-1 tw-text-md">
      <ng-content></ng-content>
    </div>
  </div>
  <ng-container>
    <button (click)="handleClose()">
      <span class="material-icons tw-mr-1 tw-text-md">close</span>
    </button>
  </ng-container>
</div>
